<template>
  <!-- This example requires Tailwind CSS v2.0+ -->
<div class="fixed inset-0 overflow-hidden z-50" role="dialog" aria-modal="true">
  <div class="absolute inset-0 overflow-hidden">
    <!-- Background overlay, show/hide based on slide-over state. -->
    <div @click="$emit('close')" class="absolute inset-0" aria-hidden="true"></div>

    <div class="fixed inset-y-0 right-0 pl-0 max-w-full flex sm:pl-16">
      <!--
        Slide-over panel, show/hide based on slide-over state.

        Entering: "transform transition ease-in-out duration-500 sm:duration-700"
          From: "translate-x-full"
          To: "translate-x-0"
        Leaving: "transform transition ease-in-out duration-500 sm:duration-700"
          From: "translate-x-0"
          To: "translate-x-full"
      -->
      <div class="w-screen max-w-md">
        <div class="h-full flex flex-col bg-white shadow-xl overflow-y-scroll">
          <div class="px-4 py-6 sm:px-6">
            <div class="flex items-start justify-between">
              <h2 id="slide-over-heading" class="text-lg font-medium text-gray-900">
                Details
              </h2>
              <div class="ml-3 h-7 flex items-center">
                <button @click="$emit('close')" class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:ring-2 focus:ring-indigo-500">
                  <span class="sr-only">Close panel</span>
                  <!-- Heroicon name: outline/x -->
                  <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <!-- Main -->
          <div>
            <div class="pb-1 sm:pb-6">
              <div>
                <div 
                class="block w-full h-36 bg-contain bg-center bg-no-repeat relative" 
                style="width: 100%; padding-top: 100%" 
                :style="{'background-image': `url(${productData.featured_image}`}">
                </div>
              </div>
            </div>
            <div class="px-4 pt-5 pb-5 sm:px-0 sm:pt-0">
              <dl class="space-y-8 px-4 sm:px-6 sm:space-y-6">
                <div>
                  <dt class="text-sm font-medium text-gray-500 sm:w-40 sm:flex-shrink-0">
                    Beschreibung
                  </dt>
                  <dd class="mt-1 text-sm text-gray-900 sm:col-span-2">
                      <div v-html="productData.description"></div>
                  </dd>
                </div>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
    name: 'ProductSlideover',
    props: ['productData']
}
</script>

<style>

</style>